import React from "react";
import ResetForm from "./ResetForm";
import { Actions } from "../../../core/modules/Actions";

const ResetDeviceIdForm = ({ onclickcancel = () => {} }) => {
  return (
    <ResetForm
      onclickcancel={onclickcancel}
      title="Reset Student's Device ID"
      buttonText="Reset Device ID"
      placeholder="Enter student email address"
      onSubmitAction={Actions.common.resetDeviceId}
    />
  );
};

export default ResetDeviceIdForm;
